import React from 'react';
import { useSelector } from 'react-redux';

function SettingsFunctionsGuard({ children, settingId = '', prob = false }) {
  const { actualRol } = useSelector((state) => state.dagpacketRoles);

  let component;
  if (actualRol?.confPermissions?.includes(settingId)) {
    component = children;
  } else {
    component = <>{null}</>;
  }

  return component;
}

export default SettingsFunctionsGuard;
